import React, {useState, useEffect} from 'react';
import GoogleMapReact from 'google-map-react';
import PinMarker from './PinMarker.jsx';
import InfoWindow from './InfoWindow.jsx';
import WeatherInfo from './WeatherInfo.jsx';
import getGoogleApi from '../../../../global/helpers/getGoogleApiKey';

const MapViewBlock = (props) => {
	const apiKey = getGoogleApi();
	// const zoom = props.zoom ? props.zoom : 13;
	// const [moveToTriggerSearch, setMoveToTriggerSearch] = useState(true);

	const [rmap, setMap] = useState(null);
	const [rmaps, setMaps] = useState(null);
	const [directionsService, setDirectionsService] = useState({});
	const [walkingDirectionsDisplay, setWalkingDirectionsDisplay] = useState({});
	const [drivingDirectionsDisplay, setDrivingDirectionsDisplay] = useState({});

	const [walkingTime, setWalkingTime] = useState('');
	const [weatherGeo, setWeatherGeo] = useState({});
	const [errorState, setErrorState] = useState(false);
	const [carParkShowingDirections, setCarParkShowingDirections] = useState(null);
	const [markerHeight, setMarkerHeight] = useState(48);
	const [markers, setMarkers] = useState([]);
	// const handleMoveToTriggerSearch = () => {
	// 	setMoveToTriggerSearch(!moveToTriggerSearch);
	// };

	useEffect(() => {
		if (props.OnFilterList) {
			// eslint-disable-next-line new-cap
			props.OnFilterList(rmap);
		}
	}, [rmap, props.carParks]);

	useEffect(() => {
		if (rmap && rmaps && props.carParks) {
			setMarkers(renderMarkers(rmap, rmaps));
		}
	}, [rmap, rmaps, props.carParks]);

	const geocodeLatLng = (geocoder, location) => {
		let latlng = {lat: location.lat, lng: location.lng};

		geocoder.geocode({location: latlng}, (results, status) => {
			if (status === 'OK') {
				if (results[0]) {
					props.handleCurrentAddress(results[0].formatted_address);
				} else {
					window.alert('No results found');
				}
			} else {
				window.alert('Geocoder failed due to: ' + status);
			}
		});
	};

	let lineSymbol = {
		path: 'M 0,-1 0,1',
		strokeOpacity: 1,
		scale: 4,
		strokeColor: 'red',
	};

	let renderOptions = {
		polylineOptions: {
			strokeOpacity: 0,
			icons: [
				{
					icon: lineSymbol,
					offset: '0',
					repeat: '20px',
				},
			],
		},
		preserveViewport: true,
	};

	const renderMarkers = (map, maps)=> {
		let _markers = [];
		if (markers.length) setMapOnAll(null);
		props.carParks.map((el, index) => {
			const _icon = el.externalCarParkInfo ? el.externalCarParkInfo.pinUrl : '/assets/images/map/pin.png';
			const marker = new maps.Marker({
				position: new maps.LatLng(el.location.latitude, el.location.longitude),
				icon: {
					url: _icon,
					scaledSize: new maps.Size(36, 48),
				},
				optimized: true,
				map: map,
			});

			marker.addListener('click', (e)=>{
				setTimeout(()=> {
					onPriceMarkerClick(e, el);
				}, 200);
			});

			_markers.push(marker);
		});
		return _markers;
	};

	const setMapOnAll = (map) => {
		for (let i = 0; i < markers.length; i++) {
			markers[i].setMap(map);
		}
	};

	const handleApiLoaded = (map, maps) => {
		if (maps) {
			let _directionsService = new maps.DirectionsService();

			let _walkingDirectionsDisplay = new maps.DirectionsRenderer(renderOptions);
			let _drivingDirectionsDisplay = new maps.DirectionsRenderer();

			let geocoder = new maps.Geocoder();

			// decode current address location
			if (props.currentLocation.coords !== undefined && props.currentLocation.coords) {
				let location = {
					lat: props.currentLocation.coords.latitude,
					lng: props.currentLocation.coords.longitude,
				};
				geocodeLatLng(geocoder, location);
			} else {
				props.handleCurrentAddress('available, please enable location services.');
			}

			// if call render outside loaded API
			// provide top level const params
			// console.log(map, maps);

			setMap(map);
			setMaps(maps);
			setDirectionsService(_directionsService);

			setWalkingDirectionsDisplay(_walkingDirectionsDisplay);
			setDrivingDirectionsDisplay(_drivingDirectionsDisplay);

			_walkingDirectionsDisplay.setMap(map);
			setCarParkShowingDirections(props.activeCarPark);

			// console.log(map, maps);

			// if call render inside loaded API
			// calculateAndDisplayRoute(_directionsService, _directionsDisplay, [_start, _end]);
		}
	};

	const calculateAndDisplayRoute = (directionsService, directionsDisplay, [start, end], mode) => {
		directionsDisplay.setMap(rmap);

		directionsService.route(
			{
				origin: start,
				destination: end,
				travelMode: mode,
			},
			(response, status) => {
				if (status === 'OK') {
					console.log(response);

					let dist = response.routes[0].legs[0].distance.text;
					let time = response.routes[0].legs[0].duration.text;

					setWalkingTime(`${dist}, ${time} ${mode == 'WALKING' ? 'walk' : 'drive'}`);

					directionsDisplay.setDirections(response);
				} else {
					setErrorState(true);
					setTimeout(() => {
						setErrorState(false);
					}, 3000);
					// window.alert('Directions request failed due to ' + status);
				}
			}
		);
	};

	const latLngToPixel = (mapLatLng) => {
		let projection = rmap.getProjection();
		let bounds = rmap.getBounds();
		let topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
		let bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
		let scale = Math.pow(2, rmap.getZoom());
		let worldPoint = projection.fromLatLngToPoint(new rmaps.LatLng(mapLatLng.latitude, mapLatLng.longitude));
		const position = {
			x: (worldPoint.x - bottomLeft.x) * scale,
			y: (worldPoint.y - topRight.y) * scale,
		};
		return position;
	};

	const pixelToLatLng = (mapLatLng) => {
		const pos = latLngToPixel(mapLatLng);
		pos.y = pos.y - markerHeight - 11;
		let ne = rmap.getBounds().getNorthEast();
		let sw = rmap.getBounds().getSouthWest();
		let projection = rmap.getProjection();
		let topRight = projection.fromLatLngToPoint(ne);
		let bottomLeft = projection.fromLatLngToPoint(sw);
		let scale = Math.pow(2, rmap.getZoom());
		let newLatlng = projection.fromPointToLatLng(new rmaps.Point(pos.x / scale + bottomLeft.x, pos.y / scale + topRight.y));
		return {lat: newLatlng.lat(), lng: newLatlng.lng()};
	};

	const onPriceMarkerClick = (event, marker) => {
		const $target = event.domEvent? event.domEvent.target : event.target;
		if ($target) setMarkerHeight($target.offsetHeight);
		props.handleClickMarker(marker);
		// center map by clicked marker.
		rmap.panTo({
			lat: marker.location.latitude,
			lng: marker.location.longitude,
		});
	};

	const showPath = (selectedCarPark) => {
		if (rmap !== {} && rmaps !== {}) {
			let selectedCarParkLatLng = new rmaps.LatLng(selectedCarPark.latitude, selectedCarPark.longitude);

			let destinationLatLng = new rmaps.LatLng(props.destination.lat, props.destination.lng);

			setWeatherGeo({
				lat: selectedCarPark.latitude,
				lng: selectedCarPark.longitude,
			});

			// if user current location is available...
			if (props.currentLocation.coords !== undefined && props.currentLocation.coords) {
				let currentPos_ = new rmaps.LatLng(
					props.currentLocation.coords.latitude,
					props.currentLocation.coords.longitude
				);

				calculateAndDisplayRoute(
					directionsService,
					drivingDirectionsDisplay,
					[currentPos_, selectedCarParkLatLng],
					'DRIVING'
				);
				calculateAndDisplayRoute(
					directionsService,
					walkingDirectionsDisplay,
					[selectedCarParkLatLng, destinationLatLng],
					'WALKING'
				);
			} else {
				calculateAndDisplayRoute(
					directionsService,
					walkingDirectionsDisplay,
					[selectedCarParkLatLng, destinationLatLng],
					'WALKING'
				);
			}

			rmap.setZoom(13);
		}
	};

	/**
	 * might need in the future
	 * to display the route on react map
	 * component including driving and walking path
	 */
	// const showCarParkPath = () => {
	// 	if (!!props.activeCarPark) {
	// 		showPath(props.activeCarPark.location);
	// 		setCarParkShowingDirections(props.activeCarPark)
	// 	} else {
	// 		if (drivingDirectionsDisplay.setDirections !== undefined) {
	// 			drivingDirectionsDisplay.setMap(null);
	// 			drivingDirectionsDisplay.setDirections(null);
	// 			walkingDirectionsDisplay.setMap(null);
	// 			walkingDirectionsDisplay.setDirections(null);
	// 			setCarParkShowingDirections(null)
	// 		}
	// 	}
	// };

	// useEffect(() => {
	// 	console.log(props.zoom);
	// }, [props.zoom]);

	useEffect(() => {
		if (props.mapData.center) {
            console.log('useEffect ~ props.mapData.center', props.mapData.center);
			setWeatherGeo({
				lat: props.mapData.center.lat,
				lng: props.mapData.center.lng,
			});
		}
	}, [props.mapData.center]);

	function onMapChange(params) {
		const {center, zoom, bounds, marginBounds} = params;
		if (props.onMapChange) {
			// props.onMapChange(center, zoom > 10 ? zoom : 10, bounds, marginBounds, rmap);
			props.onMapChange(center, zoom, bounds, marginBounds, rmap);
		}
		if (props.OnFilterList) {
			// eslint-disable-next-line new-cap
			props.OnFilterList(rmap);
		}
	}

	if (!props.mapData.center) return null;
	return (
		// Important! Always set the container height explicitly
		<div className="mapViewBlockReact position-relative" style={{height: '100%', width: '100%'}}>
			<GoogleMapReact
				bootstrapURLKeys={{key: apiKey}}
				center={props.mapData.center}
				// defaultZoom={zoom}
				yesIWantToUseGoogleMapApiInternals
				onGoogleApiLoaded={({map, maps}) => handleApiLoaded(map, maps)}
				className="googleMapReact"
				// onChildClick={onChildClick}
				onChange={onMapChange}
				zoom={props.zoom}
				minZoom={1}
				options={{gestureHandling: 'greedy', clickableIcons: false}}
			>
				{/* render the price markers */}
				{/* {props.carParks.map((el, index) => (
					<PriceMarker
						key={`coords_${el.location.latitude}_${el.location.longitude}`}
						index={index}
						name={el.name}
						address={el.location.address}
						price={el.rates[0] === undefined ? 0 : el.rates[0].rates[0].price}
						lat={el.location.latitude}
						lng={el.location.longitude}
						isWilsonOne={el.carParkFeature.includes('Wilson One')}
						onClick={(event)=>{
							onPriceMarkerClick(event, el);
						}}
						// isWilsonOne={el.isWilsonOne}
						// center={props.mapData.center}
						// onChange={onMapChange}
					/>
				))} */}

				<PinMarker {...props.destination} />

				{!!props.activeCarPark && props.infoWindowData && props.infoWindowData.location && (
					<InfoWindow
						setBookOnlinePark={props.setBookOnlinePark}
						setBookOnlineState={props.setBookOnlineState}
						setCarParkCode={props.setCarParkCode}
						type={props.type}
						{...props.infoWindowData}
						lng={props.infoWindowData.location.longitude}
						lat={pixelToLatLng(props.infoWindowData.location).lat}
						walkingTime={props.activeCarPark === carParkShowingDirections? walkingTime:''}
						clearInfo={props.clearInfo}
						ctaText={props.ctaText}
						ctatarget={props.ctatarget}
						services={props.activeCarPark.services}
						formatBookUrl={props.formatBookUrl}
						// showCarParkPath={showCarParkPath}
						destination={props.destination}
						iconBookOnline={props.iconBookOnline}
						iconMonthlyParking={props.iconMonthlyParking}
						iconParkingCard={props.iconParkingCard}
						iconEvCharger={props.iconEvCharger}
						iconLabelBookOnline={props.iconLabelBookOnline}
						iconLabelMonthlyParking={props.iconLabelMonthlyParking}
						iconLabelParkingCard={props.iconLabelParkingCard}
						iconLabelEvCharger={props.iconLabelEvCharger}
						cpms={props.cpms}
						highlightClass={props.activeCarPark.featuredIndex && props.activeCarPark.featuredIndex > 0? 'carpark-feature':''}
					/>
				)}
			</GoogleMapReact>
			{/* popup weather infomation window */}
			<WeatherInfo weatherGeo={weatherGeo} />
			{errorState && (
				<div className="map-alert map-interact-check py-2 px-3 form-check d-flex align-items-center">
					⚠️ Could not establish direction
				</div>
			)}
		</div>
	);
};

export default MapViewBlock;
